import React, { Component, createRef } from 'react';
import { Segment, Container, Input, List, Label, Divider, Tab, Grid, Header, Image, Button, Menu, MenuItem, Dropdown, Icon, Transition, Checkbox, Popup } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import fuzzysort from 'fuzzysort';
import axios from 'axios';
import '../App.css';
import { API_URL, WEB_URL } from '../App.js';
import { YugtunLoader, WordItem, TagColors } from './SearchHelper.js';
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
import { sanitize } from 'dompurify';
// import {categories} from './constants/categories.js';
// import {categoriesUrlLookup} from './constants/categoriesUrlLookup.js';

// import { dialogueGenerator } from './constants/dialogueListGenerator.js';
//test

import * as Scroll from 'react-scroll';
// import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
// import ReactGA from "react-ga4";
// ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;
var categories = {}

const options1 = {
  keys: ['transcript'],
  limit: 40, // don't return more results than you need!
  threshold: -50, // don't return bad results
  // threshold: -Infinity, // don't return bad results
};


const sortOptions = [
  { key: 'id', text: 'ID (oldest)', value: 1 },
  { key: 'id', text: 'ID (newest)', value: 2 },
  { key: 'k', text: 'Kiŋikmiut (alphabetical)', value: 3 },
  { key: 'e', text: 'English (alphabetical)', value: 4 },
]

const showOptions = [
  { key: 'all', text: 'All Terms', value: 1 },
  { key: 'Kinship', text: 'Kinship Terms', value: 2 },
  { key: 'Color', text: 'Color Terms', value: 3 },
  { key: 'Direction', text: 'Direction Terms', value: 4 },
  { key: 'Body', text: 'Body Terms', value: 5 },
]

let englishShowOptions = {
  2:'Kinship',
  3:'Color',
  4:'Direction',
  5:'Body',
}


let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

let innerWidthSetting = 480
let nonLinguistic = {
  'Kiŋikmiut':'Wales - Written in Richard Atuk Phonetic Script',
  'Qawiaraq':'Kawerak - Some entries referenced from Qawiaraq Igaluik Inupiat Dictionary',
  'Qikiqtaġruk':'Kotzebue - Some entries referenced from Inupiatun Dictionary, 2nd edition',
  'Utqiaġvik':"Formerly Barrow - Some entries referenced from Iñupiaq to English Dictionary",
  'Qigiqtaq':"Shishmaref",
}


class Home extends Component {
	constructor(props) {
		super(props);
    // console.log(props.location)
		this.state = {
			search: props.location.state === undefined ? '' :props.location.state.history[0],
			wordsList: props.location.state === undefined ? [] : props.location.state.history[1],
      sortOptionValue: props.location.state === undefined ? 1 : props.location.state.history[2],
      showOptionValue: props.location.state === undefined ? 1 : props.location.state.history[3],
      homeMode: 0,
      // props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      // activeAudioIndex: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? {} : props.location.state.history[4],
      // normalizedresults: props.location.state === undefined || props.location.state.history === undefined ? false : props.location.state.history[4],
      history: props.location.state === undefined ? [] : props.location.state.history,

      parseIndex:0,
      playingAudio: false,
      prevSearch: [],
      prevWordsList: [],
      logoup:false,

      currentCategory: props.location.state === undefined ? 'all' :('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? props.location.state.currentCategory:'all'),
      childrenCategories:[],
      parentCategories:[],

      categoriesDisplayed:[],
      // combinedAudio:[],

      useExample:true,
      useConversational:true,
      usePhrasebook:true,
      audioFilterChangeable:true,

      seeMoreAcknowledgments:false,
      zoomSearchList:[...this.props.zoomSearchList],
      currentFilter:'All Videos',
      // allfilters:[...this.props.allfilters],
      // videoList:[...this.props.videoList],
      // siuSearchList:[...this.props.siuSearchList],
      // sortedSiuSearchList:[...this.props.siuSearchList],
      // sortOptionValue:1,
      // showOptionValue:1,
		}
    // console.log('new')
		this.handleRef = createRef()
		// this.handleRef2 = createRef()

    // if (props.location.state !== undefined && 'history' in props.location.state) {
    //   // console.log('hi',props.location.state.history[2])
    //   scroll.scrollTo(props.location.state.history[4]);
    // }
	}

  componentDidMount() {
    const categoriesDisplayed = [];
    for (var key of Object.keys(categories)) {
      if (!key.includes(".")) {
        categoriesDisplayed.push(key)
      }   
    }
    const queryParameters = new URLSearchParams(window.location.search)
    const category = queryParameters.get("category")
    // if (category !== null) {
    //   this.setState({activeTabIndex:3, homeMode:3, tabValue:3})
    //   if (category in categoriesUrlLookup) {
    //     this.setState({currentCategory:categoriesUrlLookup[category] })
    //     this.retrieveFamilyCategories(categoriesUrlLookup[category])
    //   } else {
    //     this.props.history.push('/?category=all')
    //   }      
    // }
    this.setState({ categoriesDisplayed: categoriesDisplayed });

    if (this.state.sortOptionValue !== 1 || this.state.showOptionValue !== 1) {
      this.showSiuList();
      this.sortSiuList();
    }
    scroll.scrollTo(0)
    // console.log(this.props.audioSearchList)
    // console.log(this.props.audiolibrary)
    // this.setState({combinedAudio:[...this.props.audioSearchList,...this.props.audiolibrary]})
    // this.setState({combinedAudio:this.props.audiolibrary})
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentCategory !== 'all' && this.state.parentCategories.length == 0 && this.state.childrenCategories.length == 0) {
      this.retrieveFamilyCategories(this.state.currentCategory)
      scroll.scrollTo(0);
    }
    if (this.state.currentCategory !== 'all' && this.state.wordsList.length == 0 && categories[this.state.currentCategory].links.length>0) {
      this.retrieveFamilyCategories(this.state.currentCategory)
      scroll.scrollTo(0);
    }

    if (this.state.useExample !== prevState.useExample || this.state.useConversational !== prevState.useConversational || this.state.usePhrasebook !== prevState.usePhrasebook) {
      this.onChangeSearch(true, 2, null,this.state.search)
    }
    // if (this.state.sortOptionValue !== 1 || this.state.showOptionValue !== 1) {
    //   this.showSiuList()
    // }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll)
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    this.setState({
      Yposition: winScroll,
    })
  }

  setHistory = (num) => {
    this.setState({
      prevSearch:num[0],
      prevWordsList:num[1],
    })
  }

  resetAll = (e,data) => {
  	this.setState({
  		search:"",
      // newSearchList:[],
      searchWord:"",
  	})
  }



		returnTitle = (word) => {
			let newword = word.split(' | ');
			let fulllist = [];
			for (let i = 0; i < newword.length; i++) {
				if (newword[i].includes('(‐)')) {
					fulllist.push(newword[i].split('(‐)')[0])
					fulllist.push(newword[i].split('(‐)')[0]+'‐')
				} else {
					fulllist.push(newword[i])
				}
			}
			return fulllist
		}

		returnDefinition = (word) => {
			let newword = word.split(' | ')
			return newword
		}
    tlingitNormalize = (tlingit) => {
      tlingit = tlingit.replaceAll('Á','Á').replaceAll('Á','Á')
      tlingit = tlingit.replaceAll('É','É').replaceAll('É','É')
      tlingit = tlingit.replaceAll('Í','Í').replaceAll('Í','Í')
      tlingit = tlingit.replaceAll('Ó','Ó').replaceAll('Ó','Ó')
      tlingit = tlingit.replaceAll('Ú','Ú').replaceAll('Ú','Ú')
      tlingit = tlingit.replaceAll('á','á').replaceAll('á','á')
      tlingit = tlingit.replaceAll('é','é').replaceAll('é','é')
      tlingit = tlingit.replaceAll('í','í').replaceAll('í','í')
      tlingit = tlingit.replaceAll('ó','ó').replaceAll('ó','ó')
      tlingit = tlingit.replaceAll('ú','ú').replaceAll('ú','ú')
      tlingit = tlingit.replaceAll('ʼ',"'")
      tlingit = tlingit.replaceAll('̱','̲')
      tlingit = tlingit.replaceAll('Ḵ','K̲')
      tlingit = tlingit.replaceAll('ḵ','k̲')
      return tlingit
    }

    returnCorrectAudioLibrary = () => {
        if (this.state.useExample && this.state.useConversational && this.state.usePhrasebook) {
          return this.props.audiolibrary
        } else if (this.state.useExample && this.state.useConversational ) {
          return this.props.oneandtwo
        } else if (this.state.useConversational && this.state.usePhrasebook ) {
          return this.props.twoandthree
        } else if (this.state.useExample && this.state.usePhrasebook ) {
          return this.props.oneandthree
        } else if (this.state.useExample) {
          return this.props.examplesentenceaudio1
        } else if (this.state.useConversational) {
          return this.props.conversational2
        } else if (this.state.usePhrasebook) {
          return this.props.phrasebookaudio3
        } else { // edge case
          return this.props.audiolibrary
        }
    }

  	onChangeSearch = (bool,homeMode,event,data) => {
      let word
      let siuSearchListToUse = this.state.zoomSearchList
      // if (this.state.showOptionValue != 1) {
      //   siuSearchListToUse = this.state.sortedSiuSearchList
      // } else {
      //   siuSearchListToUse = this.state.siuSearchList
      // }
      if (bool) {
        word = data
      } else {
        word = data.value
        homeMode = this.state.homeMode
      }
      this.setState({'normalizedresults':false})
	    let new_search
      let new_search_normal
      let wordsList
      word = this.tlingitNormalize(word)
      new_search = word.replaceAll('s/he','').replaceAll('O-S-ø-','').replaceAll('S-ø-','').replaceAll(' (Ø act)','').replaceAll(' (Ø state)','').replaceAll('x̱','x̲')
      new_search_normal = word.replaceAll('s/he','').replaceAll('O-S-ø-','').replaceAll('S-ø-','').replaceAll(' (Ø act)','').replaceAll(' (Ø state)','').replaceAll('x̱','x̲').replaceAll("x̲","x").replaceAll("x̲'","x").replaceAll("x'","x").replaceAll("k̲","k").replaceAll("k̲'","k").replaceAll("k'","k").replaceAll("g̲","g")

	    if (false && homeMode === 0) {
        wordsList = fuzzysort.go(new_search, siuSearchListToUse, options1) 
      } else {
        wordsList = fuzzysort.go(new_search, siuSearchListToUse, options1)         
      }

	    this.setState({ wordsList: wordsList, search: word,  activeAudioIndex: {} },()=>{this.setState({audioFilterChangeable:true})});
  	}

  	processStyledText = (sentence) => {
      sentence = sentence.replaceAll("???","...")
      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«",'"').replaceAll("»",'"')

      return <span>{sentence}</span>

      // let matches = sentence.match(/⎡.*?⎤/g)
      // let matches1 = sentence.match(/{.*?}/g)
      // let matches2 = sentence.match(/_.*?_/g)
      // // console.log(matches2)
      // if (matches !== null || matches1 !== null || matches2 !== null) {
      //   if (matches !== null) {
      //     matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
      //   }
      //   if (matches1 !== null) {
      //     matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
      //   }
      //   if (matches2 !== null) {
      //     matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
      //   }
      //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      // } else {
      //   return <span>{sentence}</span>
      // }


  	}


    processStyledTextLink = (sentence) => {
      sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("↞","").replaceAll("&","").replaceAll("↠","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
      }


    }

  	processUsageDefinition = (definition, tag, ind) => {
  		// console.log(definition)
			let matches = definition.match(/<.*?>/g)

			if (matches !== null) {
				matches.map((m) => definition = definition.replaceAll(m,"<i>"+m.slice(1,-1)+'</i>'))				
			}
			let matches1 = definition.match(/⎡.*?⎤/g)
			if (matches1 !== null) {
				matches1.map((m) => definition = definition.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))				
			}

      let matches2 = definition.match(/_.*?_/g)
      if (matches2 !== null) {
        matches2.map((m) => definition = definition.replaceAll(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
      }

      let matches3 = definition.match(/{.*?}/g)
      if (matches3 !== null) {
        matches3.map((m) => definition = definition.replaceAll(m,m.slice(1,-1)))            
      }

			if (tag !== 'noun') {
				definition = '<i>s/he/it is </i>'+definition
			}

			definition = definition.replaceAll("⟨","").replaceAll("⟩","")

  		return <span dangerouslySetInnerHTML={{__html: definition}} />
  	}		


  	processAudioDefinition = (sentence) => {			
      // console.log(sentence)
			let matches = sentence.match(/⎡.*?⎤/g)
			if (matches !== null) {
				matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))				
			}
			sentence = sentence.replaceAll('>','')
			// console.log(sentence)
			// var dom = document.createElement('span');
			// dom.innerHTML = sentence;
  		return <span dangerouslySetInnerHTML={{__html: sentence}} />
  	}


  repeatAudio(audio, event, data) {
    // console.log(audio, event, data)
    // var a = new Audio(API_URL+'static/WoW-Link.mp3');
    // a.play();
    // let a;
    // axios
    //   .get(API_URL + "/audiolibrary/" + audio.mp3)
    //   .then(response => {
    //     // let end = now();
    //     // ReactGA.timing({
    //     //   category: 'Loading',
    //     //   variable: 'dictionary',
    //     //   value: (end-start).toFixed(3),
    //     //   label: 'Dictionary loading'
    //     // });
    //     var a = new Audio(response.data);
    //     console.log(a)
    //     a.play();
    //     // fuse.setCollection(dictionary);
    //     // fuse1.setCollection(dictionary);
    //     // console.log('Fetched dictionary');

    //     // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
    //     // // dictionary_prepared = fuzzysort.prepare(dictionary)

    //     // this.setState({ dictionary: dictionary });
    //   });
    if (!this.state.playingAudio) {

      let sound = new Audio(API_URL + "/tlingitaudiolibrary/" + audio);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }


  onKeyPress(event, data) {

    // console.log(event, data, this.state)
    
    if (event.key === 'Enter' && this.state.wordsList.length > 0) {
      let audio = this.state.wordsList[0].obj.mp3
      let sound = new Audio(API_URL + "/tlingitaudiolibrary/" + audio);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }

  // soundDone = () => {
  //   console.log('done!')
  // }

  setActiveAudioIndex = (word, index) => {
    // console.log(word, index)
    let activeAudioIndex = this.state.activeAudioIndex
    if (index in activeAudioIndex) {
      delete activeAudioIndex[index]
      this.setState({activeAudioIndex:activeAudioIndex})
    } else {
      // activeAudioIndex[index] = ""
      // this.setState({activeAudioIndex:activeAudioIndex})
      // console.log(word)

      axios
        .get(API_URL + "/tlingitaudiolibraryword/" + word.obj.key)
        .then(response => {
          // let end = now();
          // ReactGA.timing({
          //   category: 'Loading',
          //   variable: 'dictionary',
          //   value: (end-start).toFixed(3),
          //   label: 'Dictionary loading'
          // });
          // audiolibrary = response.data;
          // fuse.setCollection(dictionary);
          // fuse1.setCollection(dictionary);
          activeAudioIndex[index] = response.data
          this.setState({activeAudioIndex:activeAudioIndex})
          // console.log(response.data);
          // activeAudioIndex[index] = response.data
          // this.setState({activeAudioIndex:activeAudioIndex})

          // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
          // dictionary_prepared = fuzzysort.prepare(dictionary)

          // this.setState({ audiolibrary: audiolibrary });
        });


    }
    // console.log(activeAudioIndex)
    // this.setState({activeAudioIndex:activeAudioIndex})
  }



  handleTabChange = (e,data) => {
    // console.log(data.activeIndex, this.state.activeIndex)
    if (data.activeIndex == this.state.activeTabIndex) {
      this.resetAll()
    }

    if (data.activeIndex === 0 && this.state.activeTabIndex !== 0) {
      this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:0})
      this.onChangeSearch(true, 0, null,this.state.search)
      this.props.history.push('/')
    } else if (data.activeIndex === 1 && this.state.activeTabIndex !== 1) {
      // if (!this.state.yugtunAnalyzer) {
      this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:1});                     
      this.onChangeSearch(true, 1, null,this.state.search)
      this.props.history.push('/')
      // this.inputClicked()
      // }
    } else if (data.activeIndex === 2 && this.state.activeTabIndex !== 2) {
      // if (!this.state.yugtunAnalyzer) {
      this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:2});                     
      this.onChangeSearch(true, 2, null,this.state.search)
      this.props.history.push('/')
      // this.inputClicked()
      // }
    }else if (data.activeIndex === 3 && this.state.activeTabIndex !== 3) {
      // if (!this.state.yugtunAnalyzer) {
      this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:3});   
      this.props.history.push('/?category=all')                  
      // this.onChangeSearch(true, 3, null,this.state.search)
      // this.inputClicked()
      // }
    }
  }



  handleTabChange2 = (e, {value}) => {

    if (value == this.state.tabValue) {
      this.resetAll()
    }

    if (value === 0 && this.state.tabValue !== 0) {
      this.setState({wordsList: [], homeMode: value, activeTabIndex:0})
      this.onChangeSearch(true, 0, null,this.state.search)
      this.props.history.push('/')
    } else if (value === 1 && this.state.tabValue !== 1) {
      this.setState({wordsList: [], homeMode: value, activeTabIndex:1});                     
      this.onChangeSearch(true, 1, null,this.state.search)
      this.props.history.push('/')
    } else if (value === 2 && this.state.tabValue !== 2) {
      this.setState({wordsList: [], homeMode: value, activeTabIndex:2});                     
      this.onChangeSearch(true, 2, null,this.state.search)
      this.props.history.push('/')
    } else if (value === 3 && this.state.tabValue !== 3) {
      this.setState({wordsList: [], homeMode: value, activeTabIndex:3});     
      this.props.history.push('/?category=all')                
      // this.onChangeSearch(true, 3, null,this.state.search)
    }
  	this.setState({tabValue: value})
  }

  // randomizeSentence = (direction) => {
  //   if (direction === '+') {
  //     if (this.state.randomSentences.length-1 === this.state.randomSentenceIndex) {
  //       this.setState({randomSentenceIndex: 0})        
  //     } else {
  //       this.setState({randomSentenceIndex: this.state.randomSentenceIndex+1})        
  //     }
  //   } else {
  //     this.setState({randomSentenceIndex: this.state.randomSentenceIndex-1})
  //   }
  // }

  // newUsageBaseDisplay = (word) => {
  //   // console.log(word)

  //   let returnNewUsageBaseDisplayLabel = {
  //     'verb phrase':[
  //       'present',
  //       'past',
  //       'question',
  //       'polite command',
  //       'command',
  //     ],
  //     'noun':[
  //       'stem',
  //       'possessive',
  //       'locative noun case',
  //       'with pronoun',
  //     ],
  //   }
  //   return  <List.Item>
  //             <List.Content style={{fontSize:'16px',paddingTop:'8px',paddingBottom:'10px'}}><span style={{paddingRight:'20px',fontWeight:'500'}}>{word.url.replaceAll(',',', ')}</span><span style={{paddingRight:'15px',fontStyle:'italic'}}>{this.processStyledText(word.thisDefinition)}</span><span style={{'marginLeft':'15px',marginRight:'6px',cursor:'pointer'}}><TagColors tags={word.t} width={window.innerWidth} /></span></List.Content>
  //             {word.newUsageDefinitions.map((u,uindex)=>
  //             <List.Content style={{paddingLeft:'20px'}}>
  //               <Link to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[uindex], usagedictionary_dict: this.props.usagedictionary_dict, activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //                 <List.Content floated='right'>
  //                   <Icon circular style={{marginTop:'3px', color:'#8f8f8f'}} size='small' name='chevron right' />
  //                 </List.Content>
  //               </Link>
  //               <List.Content style={{display:'flex',fontSize:'16px',paddingBottom:'8px',fontFamily:customFontFam,lineHeight:'25px'}}>
  //                 <span style={{flex:2,'paddingRight':'3px',fontWeight:'500'}}>
  //                 <Link style={{borderBottom:'1px solid #858585',paddingBottom:'1px',color:'#306190'}} to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[uindex], activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //                 {this.processStyledTextLink(word.usageWords[uindex])}
  //                 </Link>
  //                 </span>
  //                 <span style={{flex:5,fontSize:'16px',color:'#000000cc',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{word.newUsageDefinitions[uindex]}</span>
  //                 <span style={{flex:3,color:'#BEBEBE',fontStyle:'italic',textAlign:'right'}}>{returnNewUsageBaseDisplayLabel[word.t][uindex]}</span>
  //               </List.Content>
  //             </List.Content>
  //             )}
  //           </List.Item>

  //   // return <List.Item>
  //   // <Link to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[0], activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, word: word.usageWord, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //   //   <List.Content floated='right'>
  //   //     <Icon circular style={{marginTop:'8px', color:'#8f8f8f'}} size='large' name='chevron right' />
  //   //   </List.Content>
  //   // </Link>
  //   //   <List.Content>
  //   //     <List.Header style={{fontSize:'16px',paddingBottom:'4px',fontFamily:customFontFam,lineHeight:'25px'}}>
  //   //       <div> 
  //   //       <span style={{'paddingRight':'3px',fontWeight:'500'}}>
  //   //       <Link style={{borderBottom:'1px solid #858585',paddingBottom:'1px',color:'#306190'}} to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[0], activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, word: word.usageWord, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //   //       {this.processStyledText(word.usageWord)}
  //   //       </Link>
  //   //       </span>
  //   //       <span style={{'marginLeft':'15px',marginRight:'6px',cursor:'pointer'}}>  
  //   //         <TagColors tags={word.t} width={window.innerWidth} />
  //   //       </span>
  //   //       </div>
  //   //     </List.Header>
  //   //     <List.Description style={{fontSize:'16px',color:'#000000cc',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{this.processUsageDefinition(word.usageDefinition,word.t,i)}</List.Description>
  //   //   </List.Content>
  //   // </List.Item>
  // }

  spanParses = (spanList,fontSize,fontWeight) => {
    return spanList.map((t,tindex)=>{
      let entries = [...t[1],...t[2]]
      let maxLength = (entries.length % 2 == 0 ? entries.length/2 : (entries.length+1)/2)

      if (entries.length == 0) {

        return <span style={{marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'6px',fontSize:fontSize, fontWeight:fontWeight, borderBottom:'2px dotted white'}}>
          {this.processStyledText(t[0])}
        </span>

      } else {

        return <Popup hideOnScroll on='click' position='bottom center' onClose={()=>{this.setState({parseIndex:0})}} content={
          <div style={{fontFamily:customFontFam, fontSize:'16px'}}>
            <div style={{textAlign:'center',fontStyle:'italic',color:'#aeaeae',margin:3}}>Possible Entries</div>
            {entries.map((k,kindex)=>{
              if (kindex == this.state.parseIndex*2 || kindex == this.state.parseIndex*2+1) {
              return <div style={{marginTop:15,marginBottom:10}}>
                  <div style={{display:'flex',alignItems:'center',flexDirection:'row',fontWeight:'500'}}>
                        {k['url'].length === 0 ?
                          <span style={{whiteSpace:'nowrap'}}>{k['tlingit']}</span>
                          :
                          <a style={{whiteSpace:'nowrap'}} href={"https://www.haashuka.com/"+k['url']} target="_blank">{k['tlingit']}</a>
                        }
                        {k['tags'].map((t,tindex)=>
                            (tindex === 0 && t.length != 0 ?
                        <span style={{display:'flex',marginLeft:'12px'}}>
                          <TagColors homeMode={0} tags={t} width={window.innerWidth} />
                        </span>
                        :
                        null
                        )
                      )}
                  </div>
                  <div style={{fontStyle:'italic',marginTop:'5px'}}>{k['english']}</div>
              </div>
              }})}

            {this.state.parseIndex+1 < maxLength+1 && maxLength > 1 ?
              <div style={{display:'flex',justifyContent:'center',marginTop:'12px'}}>
              <Icon disabled={this.state.parseIndex === 0} circular onClick={() => this.setState({parseIndex: this.state.parseIndex-1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron left' />
              <Label basic circular style={{width:30,color:'#aeaeae',fontWeight:500,height:30,fontSize:14,}}>
                {this.state.parseIndex + 1}
              </Label>
              <Icon disabled={this.state.parseIndex+1 == maxLength} circular onClick={() => this.setState({parseIndex: this.state.parseIndex+1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron right' />
              </div>  
              :
              null
            }      
          </div>
        } trigger={
          <span style={{cursor:'pointer', marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'6px',fontSize:fontSize, fontWeight:fontWeight, borderBottom:'2px dotted #b5b5b5'}}>
            {this.processStyledText(t[0])}
          </span>
        } />

      }
    })
  }



  underlineFixer = (word) => {
    // console.log(word)
    word = word.replaceAll('g</b>̲','g̲</b>').replaceAll('G</b>̲','G̲</b>').replaceAll('x</b>̲','x̲</b>').replaceAll('X</b>̲','X̲</b>').replaceAll('k</b>̲','k̲</b>').replaceAll('K</b>̲','K̲</b>')
    word = word.replaceAll('g<b>̲</b>','g̲<b></b>').replaceAll('G<b>̲</b>','G̲<b></b>').replaceAll('x<b>̲</b>','x̲<b></b>').replaceAll('X<b>̲</b>','X̲<b></b>').replaceAll('k<b>̲</b>','k̲<b></b>').replaceAll('K<b>̲</b>','K̲<b></b>')
    word = word.replaceAll('g<b>̲','g̲<b>').replaceAll('G<b>̲','G̲<b>').replaceAll('x<b>̲','x̲<b>').replaceAll('X<b>̲','X̲<b>').replaceAll('k<b>̲','k̲<b>').replaceAll('K<b>̲','K̲<b>')
    word = word.replaceAll('a</b>́','á</b>').replaceAll('e</b>́','é</b>').replaceAll('i</b>́','í</b>').replaceAll('o</b>́','ó</b>').replaceAll('u</b>́','ú</b>')
    word = word.replaceAll('a<b>́</b>','á<b></b>').replaceAll('e<b>́</b>','é<b></b>').replaceAll('i<b>́</b>','í<b></b>').replaceAll('o<b>́</b>','ó<b></b>').replaceAll('u<b>́</b>','ú<b></b>')
    word = word.replaceAll('a<b>́','á<b>').replaceAll('e<b>́','é<b>').replaceAll('i<b>́','í<b>').replaceAll('o<b>́','ó<b>').replaceAll('u<b>́','ú<b>')
    word = word.replaceAll('A</b>́','Á</b>').replaceAll('E</b>́','É</b>').replaceAll('I</b>́','Í</b>').replaceAll('O</b>́','Ó</b>').replaceAll('U</b>́','Ú</b>')
    word = word.replaceAll('A<b>́</b>','Á<b></b>').replaceAll('E<b>́</b>','É<b></b>').replaceAll('I<b>́</b>','Í<b></b>').replaceAll('O<b>́</b>','Ó<b></b>').replaceAll('U<b>́</b>','Ú<b></b>')
    word = word.replaceAll('A<b>́','Á<b>').replaceAll('E<b>́','É<b>').replaceAll('I<b>́','Í<b>').replaceAll('O<b>́','Ó<b>').replaceAll('U<b>́','Ú<b>')
    return word
  }
  buttonGroupKeyboard = (homeMode) => {
    return  <Button.Group basic>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ā')}} style={letterbutton}>ā</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ō')}} style={letterbutton}>ō</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ġ')}} style={letterbutton}>ġ</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ł')}} style={letterbutton}>ł</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ł̣')}} style={letterbutton}>ł̣</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ḷ')}} style={letterbutton}>ḷ</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ŋ')}} style={letterbutton}>ŋ</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'p̄')}} style={letterbutton}>p̄</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'q̄')}} style={letterbutton}>q̄</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'t̄')}} style={letterbutton}>t̄</Button>
            </Button.Group>
  }

  retrieveFamilyCategories(j) {
  // console.log(categories[j])
  // const children = [];
  let parent = [];
  // for (let i = 1; i < categories[j].children + 1; i++) {
  //   children.push(j+'.'+i.toString())
  // }
  let wordsList = []

  if (this.state.homeMode === 3 && Object.keys(this.props.urlDictionary).length > 0) {
    categories[j].links.map((k)=>{
      // console.log(k)
      // console.log(Object.keys(this.props.urlDictionary).length)
      wordsList.push({'obj':{'dialect':this.props.urlDictionary[k].dialect,'soundfile':this.props.urlDictionary[k].soundfile,'url':this.props.urlDictionary[k].url, 'pos':this.props.urlDictionary[k].pos, 'lexicon':this.props.urlDictionary[k].lexicon, 'gloss':this.props.urlDictionary[k].gloss}})
    })
    
    this.props.history.push('/?category='+categories[j].url)
    // console.log(j)
    // if (j.includes('.')) {
    //   var p = j.split('.');
    //   for (let k = 1; k < p.length; k++) {
    //     parents.push((p.slice(0,k)).join('.'))
    //   }
    // }

    if ('parent' in categories[j]) {
      parent = categories[j].parent
    }

    this.setState({ 
      currentCategory: j,
      childrenCategories: categories[j].children,
      parentCategories: parent,
      // parentCategories: parents,
      wordsList:wordsList,
      });    
  }

}

  isLetter(str) {
    return str.length === 1 && str.match(/[a-z]/i);
  }

  returnNonLinguisticTerm = (term, bottom) => {
    // console.log(term)
    // bottom = 'bottom'
    if (term in nonLinguistic) {
      return <div style={{fontSize:'16px',color:(window.innerWidth < innerWidthSetting ? '#808080' : '#777777'),fontStyle:'italic'}}>
                <Popup hideOnScroll on='click' position={bottom == 'bottom' ? 'bottom':'bottom right'} content={
                  <div style={{fontFamily:customFontFam,}}>
                    {nonLinguistic[term]}
                  </div>
                } trigger={
                  <span style={{cursor:'pointer',paddingBottom:'3px', borderBottom:'2px dotted #d5d5d5'}}>
                    {term.replaceAll('_',' ')}
                  </span>
                } />
            </div>      
    } else {
    return  <div style={{fontSize:'16px',color:(window.innerWidth < innerWidthSetting ? '#808080' : '#777777'),fontStyle:'italic'}}>
              {this.processStyledText(term.replaceAll('_',' '))}
            </div>      
          }
  }

  // sortSiuList = (e, data) => {
  //   console.log(e,data)
  //   let newSiuSearchList = [...this.props.zoomSearchList]
  //   let colorList = ['1','2','3']
  //   let sortOptionValue = 1
  //   if (data == undefined) {
  //     sortOptionValue = this.state.sortOptionValue
  //   } else {
  //     sortOptionValue = data.value
  //   }
  //   if (sortOptionValue == 1) { // ID ascending
  //     newSiuSearchList.sort((a, b) => a.id - b.id)
  //     this.setState({sortOptionValue:1,zoomSearchList:zoomSearchList},()=>{this.showSiuList();})
  //   } else if (sortOptionValue == 2) { // ID descending
  //     newSiuSearchList.sort((a, b) => b.id - a.id)
  //     this.setState({sortOptionValue:2,zoomSearchList:zoomSearchList},()=>{this.showSiuList();})
  //   } else if (sortOptionValue == 3) { //kingikmiut
  //     newSiuSearchList.sort((a, b) => a.k.localeCompare(b.k))
  //     this.setState({sortOptionValue:3,zoomSearchList:zoomSearchList},()=>{this.showSiuList();})
  //   } else if (sortOptionValue == 4) { //english
  //     newSiuSearchList.sort((a, b) => a.e.localeCompare(b.e))
  //     this.setState({sortOptionValue:4,zoomSearchList:zoomSearchList},()=>{this.showSiuList();})
  //   }
  // }

  // showSiuList = (e, data) => {
  //   console.log(e,data,this.state)
  //   let newSiuSearchList = this.state.siuSearchList
  //   // let colorList = ['1','2','3']
  //   let showOptionValue = 1
  //   if (data == undefined) {
  //     showOptionValue = this.state.showOptionValue
  //   } else {
  //     showOptionValue = data.value
  //   }

  //   if (showOptionValue == 1) { //all
  //     this.setState({showOptionValue:1,siuSearchList:this.state.siuSearchList},()=>{this.onChangeSearch(true,0,null,this.state.search)})
  //   } else {
  //     Object.keys(englishShowOptions).map((k)=>{
  //       if (showOptionValue == k) {
  //         newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes(englishShowOptions[k]))
  //         this.setState({showOptionValue:parseInt(k),sortedSiuSearchList:newSiuSearchList},()=>{this.onChangeSearch(true,0,null,this.state.search)})
  //       }
  //     })
  //   }
  //   // if (showOptionValue == 2) { //Kinship
  //   //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Kinship')) //FILTER FUNCTION
  //   //   this.setState({showOptionValue:2,sortedSiuSearchList:newSiuSearchList})
  //   // } else if (showOptionValue == 3) { //Color
  //   //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Color')) //FILTER FUNCTION
  //   //   this.setState({showOptionValue:3,sortedSiuSearchList:newSiuSearchList})
  //   // } else if (showOptionValue == 4) { //Direction
  //   //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Direction')) //FILTER FUNCTION
  //   //   this.setState({showOptionValue:4,sortedSiuSearchList:newSiuSearchList})
  //   // } else if (showOptionValue == 5) { //Body
  //   //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Body')) //FILTER FUNCTION
  //   //   this.setState({showOptionValue:5,sortedSiuSearchList:newSiuSearchList})
  //   // }
  //   // if (this.state.search.length > 0) {
  //   //   this.onChangeSearch(true,0,null,this.state.search)
  //   // }
  // }


	render() {
    // console.log(this.state)
    // console.log(this.props)
		let isCommon = false
    let displayList = (this.state.search.length >= 1 && this.state.wordsList.length > 0) || (this.state.homeMode === 3 && this.state.wordsList.length > 0);
    let wordsList = this.state.wordsList;
    if (wordsList.length == 0) {
      // if (this.state.showOptionValue != 1) {
      //   wordsList = this.state.sortedSiuSearchList
      // } else {
      //   wordsList = this.state.siuSearchList
      // }
      wordsList = this.state.zoomSearchList
    }
    let emptyList = this.state.search.length >= 1 && this.state.wordsList.length === 0 && this.state.activeTabIndex !== 3;
    let categoryMargin = '4px'
    let showLargerTable = window.innerWidth >= 480
    // let ranDem = this.state.randomSentences[this.state.randomSentenceIndex]
    // wordsList.map((k)=>{
    //   console.log(k)
    //   k = fuzzysort.highlight(k[0], '<b>', '</b>')
    //   console.log(k)
    // })

  const panes = [
    {
      menuItem: (
      	<Menu.Item style={customFontFam2}>
      	<div><span>Dictionary Entry</span> </div>
      	</Menu.Item>
      	),
    },
    {
      menuItem: (<div />),
    },
    {
      menuItem: (
      	<Menu.Item style={customFontFam2}>
      	<div><span>Audio Clip</span> </div>
      	</Menu.Item>
      	),
    },
    {
      menuItem: (
        <Menu.Item style={customFontFam2}>
        <div><span>Category</span> </div>
        </Menu.Item>
        ),
    },
    ];
		return (
			<div className="app" style={{fontFamily:customFontFam}}>
      <Grid textAlign='center'>
      <Grid.Row>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
            <Link to={{pathname: "/", state: { history:this.state.history }}} >
              <Button onClick={()=>{this.props.history.goBack()}} basic style={{paddingLeft:'10px',paddingRight:'15px',marginLeft:'3px'}} icon='left chevron' content='Back to Language Resources' />
            </Link>
            <Button basic style={{float:'right',paddingLeft:'13px',paddingRight:'15px'}} icon='linkify' onClick={() => {navigator.clipboard.writeText(WEB_URL+'?p=zoomlist'); this.setState({copyClicked:true})}} content={this.state.copyClicked ? 'Copied!' : 'Share Link'} />

          {true ?
            <div style={{padding:10, paddingTop: 30,fontWeight:'bold',justifyContent:'left',fontSize:'21px'}}>
              {'Zoom Inupiaraaqta Language Sessions with Richard Atuk'}
            </div>
            :
            null
          }
        </Grid.Column>
      </Grid.Row>


      <Grid.Row style={{ padding: 0 }}>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
            <div style={{fontSize:'16px',color:'#00000099',marginBottom:'5px',marginLeft:'10px'}}>Filters: </div>
        </Grid.Column>
      </Grid.Row>

      {showLargerTable ?
        <Grid.Row style={{paddingLeft:'20px',paddingTop:0}} columns={2} >
          <Grid.Column style={{ maxWidth: 430, padding: 10, display:'flex',flexDirection:'column' }} textAlign='left' width={8}>
          <Checkbox checked={this.state.currentFilter == 'All Videos'} onClick={()=>{this.setState({currentFilter:'All Videos'})}} style={{fontSize:'16px'}} radio label='All Videos' />
          <div style={{fontSize:'14px',color:'#00000099',margin:'10px 0px'}}>Presenters:</div>
          {this.props.allfilters['presenters'].map((k)=>
            <Checkbox checked={this.state.currentFilter == k} onClick={()=>{this.setState({currentFilter:k})}} style={{fontSize:'16px',marginRight:'15px',marginBottom:'5px'}} radio label={k} />
          )}
          <div style={{fontSize:'14px',color:'#00000099',margin:'10px 0px'}}>Speakers:</div>
          {this.props.allfilters['speakers'].map((k)=>
            <Checkbox checked={this.state.currentFilter == k} onClick={()=>{this.setState({currentFilter:k})}} style={{fontSize:'16px',marginRight:'15px',marginBottom:'5px'}} radio label={k} />
          )}
          <div style={{fontSize:'14px',color:'#00000099',margin:'10px 0px'}}>Stories:</div>
          {this.props.allfilters['stories'].map((k)=>
            <Checkbox checked={this.state.currentFilter == k} onClick={()=>{this.setState({currentFilter:k})}} style={{fontSize:'16px',marginRight:'15px',marginBottom:'5px'}} radio label={k} />
          )}
          </Grid.Column>
          <Grid.Column  style={{ maxWidth: 430, padding: 10, display:'flex',flexDirection:'column' }} textAlign='left' width={8}>
          <div style={{fontSize:'14px',color:'#00000099',marginBottom:'10px'}}>Topics:</div>
          {this.props.allfilters['topics'].map((k)=>
            <Checkbox checked={this.state.currentFilter == k} onClick={()=>{this.setState({currentFilter:k})}} style={{fontSize:'16px',marginRight:'15px',marginBottom:'5px'}} radio label={k} />
          )}
          </Grid.Column>
        </Grid.Row>
        :
        <Grid.Row style={{display:'flex',flexDirection:'column',paddingLeft:'20px'}}>
          <Checkbox checked={this.state.currentFilter == 'All Videos'} onClick={()=>{this.setState({currentFilter:'All Videos'})}} style={{fontSize:'16px'}} radio label='All Videos' />
          <div style={{fontSize:'14px',color:'#00000099',margin:'10px 0px'}}>Presenters:</div>
          {this.props.allfilters['presenters'].map((k)=>
            <Checkbox checked={this.state.currentFilter == k} onClick={()=>{this.setState({currentFilter:k})}} style={{fontSize:'16px',marginRight:'15px',marginBottom:'5px'}} radio label={k} />
          )}
          <div style={{fontSize:'14px',color:'#00000099',margin:'10px 0px'}}>Stories:</div>
          {this.props.allfilters['stories'].map((k)=>
            <Checkbox checked={this.state.currentFilter == k} onClick={()=>{this.setState({currentFilter:k})}} style={{fontSize:'16px',marginRight:'15px',marginBottom:'5px'}} radio label={k} />
          )}
          <div style={{fontSize:'14px',color:'#00000099',margin:'10px 0px'}}>Topics:</div>
          {this.props.allfilters['topics'].map((k)=>
            <Checkbox checked={this.state.currentFilter == k} onClick={()=>{this.setState({currentFilter:k})}} style={{fontSize:'16px',marginRight:'15px',marginBottom:'5px'}} radio label={k} />
          )}
        </Grid.Row>
      }


      <Grid.Row style={{ padding: 0 }}>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
          <div style={{fontSize:'16px',color:'#00000099',marginTop:'5px',marginBottom:'3px',textAlign:'center'}}>Video results by date: </div>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row style={{paddingTop:0}}>
        <Grid.Column style={{  maxWidth: 1060, padding: 0, fontFamily:customFontFam }} textAlign='left'>
          <div style={{display:'flex',flexWrap:'wrap',fontSize:'16px',justifyContent:'center'}}>
          {Object.keys(this.props.videoList).map((y,yindex)=>
          { 
            return this.props.videoList[y]['category']=='Zoom Session' && (this.state.currentFilter == 'All Videos' || this.props.videoList[y]['presenters'].includes(this.state.currentFilter) || this.props.videoList[y]['stories'].includes(this.state.currentFilter) || this.props.videoList[y]['speakers'].includes(this.state.currentFilter) || this.props.videoList[y]['topics'].includes(this.state.currentFilter)) ?
              (showLargerTable ? 
                <div style={{width:"200px",margin:'15px'}}>
                  <Link target="_blank" to={{pathname: WEB_URL+'?p=video/'+y, state: { from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.sortOptionValue, this.state.showOptionValue, this.state.Yposition] }}}>
                    <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />
                    {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                  </Link>
                  <div style={{color:'#000000DE',fontWeight:'600',fontSize:'16px',marginTop:'5px',marginBottom:'3px'}}>{this.props.videoList[y].date}</div>
                  <div style={{fontSize:'14px',lineHeight:'16px',color:'#00000099'}}>{this.props.videoList[y]['summary']}</div>
                </div>
                :
                <Grid style={{marginTop:0}}>
                  <Grid.Row columns={2} style={{alignItems:'center',margin:'3px 10px'}}>
                    <Grid.Column width={7}>
                    <Link target="_blank" to={{pathname: WEB_URL+'?p=video/'+y, state: { from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.sortOptionValue, this.state.showOptionValue, this.state.Yposition] }}}>
                      <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />
                      {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                    </Link>
                    </Grid.Column>
                    <Grid.Column width={9}>
                    <div style={{color:'#000000DE',fontWeight:'600',fontSize:'16px',marginTop:'5px',marginBottom:'3px'}}>{this.props.videoList[y].date}</div>
                    <div style={{fontSize:'14px',lineHeight:'16px',color:'#00000099'}}>{this.props.videoList[y]['summary']}</div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )
              :
              null
            }
          )}
          </div>
        </Grid.Column>
      </Grid.Row>



      </Grid>


			</div>
		);
	}
}
export default Home;